module.exports = __webpack_public_path__ + "static/media/logo-black.1d8b5961.png";